import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { ArrowDownward, Block, Save } from "@material-ui/icons";
import Config, { EXCLUDE_QUIT_STAFF } from "app/appConfig";
import CommonButton from "app/common/Component/Button/CommonButton";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconDelete from "app/common/Icon/IconDelete";
import {
  LEAD_SOURCE_LEVEL,
  PathModule,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
} from "app/common/LocalConst";
import {
  getDepartmentsUser,
  getPositionCodes,
  isAdmin,
  transformDate,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
  validateVoucherPaymentMethods,
} from "app/common/LocalFunction";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import {
  getListCode,
  pagingCustomerSource,
} from "app/services/CustomerSourceService";
import { pagingDepartment } from "app/services/DepartmentService";
import { pagingPosition } from "app/services/PositionService";
import { pagingStaff } from "app/services/StaffService";
import { useStore } from "app/stores";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import { forwardRef, memo, useEffect } from "react";
import * as Yup from "yup";
import TotalOfVoucherByDeposit from "../Component/TotalOfVoucherByDeposit";
const DepositFeePopup = ({
  open,
  handleClose,
  initialData,
  handleSubmit,
  customerSourceWalkIn,
}) => {
  const theme = useTheme();
  const { resetStorePopup, listCodeSource } =
    useStore().feeStore.serviceFeeTabStore;
  const { handleGetPatientOverviewByIdNotLoading } =
    useStore().patientManagementStore.patientGeneralStore;
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const defaultDepartment = useDefaultDepartment();
  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa cơ sở!"),
    accountant: Yup.object().nullable().required("Chưa cơ người thu!"),
    voucherDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày thu chưa đúng định dạng!")
      .nullable()
      .required("Bạn chưa chọn ngày lập!"),
    voucherPaymentMethods: Yup.array()
      .of(
        Yup.object()
          .shape()
          .test(
            "Validate voucher bank",
            "Bắt buộc chọn stk",
            validateVoucherPaymentMethods
          )
      )
      .test(
        "sum-total",
        "Tổng tiền các phương thức thanh toán phải bằng tổng tiền thu",
        function (value) {
          if (!value) return true;
          const totalAmount = this.parent.totalAmount || 0;
          const sum = value.reduce(
            (acc, curr) => acc + (parseFloat(curr.totalOfMethod) || 0),
            0
          );
          return Math.abs(sum - totalAmount) < 1;
        }
      ),
    staffRevenues: Yup.array()
      .of(
        Yup.object()
          .shape({
            position: Yup.object()
              .nullable()
              .required("Bắt buộc nhập chức danh"),
            staff: Yup.object().nullable(),
            source: Yup.object()
              .required("Bắt buộc nhập nguồn phân bổ")
              .test(
                "source-in-list",
                "Nguồn phân bổ không hợp lệ",
                function (value) {
                  const listCodeSource =
                    this.options.context?.listCodeSource || [];

                  // Nếu chưa chọn hoặc thiếu code → invalid
                  if (!value || !value.code) return false;

                  // Không có danh sách thì cho pass
                  if (listCodeSource.length === 0) return true;

                  const first = listCodeSource[0];

                  // Mảng string: ["CTV", "KR", ...]
                  if (typeof first === "string") {
                    return listCodeSource.includes(value.code);
                  }

                  // Mảng object: [{code: "CTV"}]
                  if (typeof first === "object" && first !== null) {
                    return listCodeSource.some(
                      (item) => item.code === value.code
                    );
                  }

                  return false;
                }
              )
              .nullable(),
            actualAmount: Yup.number()
              .min(0, "Phân bổ doanh thu phải lớn hơn 0!")
              .nullable(),
            percentRevenue: Yup.number()
              .nullable()
              .min(0, "Tối thiểu 0%")
              .max(100, "Tối đa 100%"),
          })
          .test(
            "at-least-one-selected",
            "Phải chọn Nhân viên!",
            function (value) {
              if (!value) return false;
              const { staff } = value;
              return !!staff;
            }
          )
      )
      .test(
        "at-least-one-diffirent-sale",
        "Cần chọn phân bổ cho người tư vấn !",
        validateSelectDiffirentTelesale
      )
      .test(
        "at-least-one-sale",
        "Cần chọn phân bổ cho telesale!",
        validateSelectTelesale
      )
      .test(
        "max-total-amount-telesale",
        "Tổng phân bổ telesale phải bằng 100%",
        validateMaxTotalAmountTelesale
      )
      .test(
        "max-total-amount-consultant",
        "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
        validateMaxTotalDiffTelesale
      )
      .test(
        "equals-source-revenue-sale-diffirent",
        "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
        validateEqualsSourceDiffirentTelesale
      )
      .nullable(),
    totalAmount: Yup.number().min(1, "Số tiền thu phải lớn hơn 0!").nullable(),
  });
  useEffect(() => {
    return () => resetStorePopup();
  }, []);

  return (
    <PopupForm
      open={open}
      size="xl"
      // height="75vh"
      handleClose={handleClose}
      title={"Đặt cọc"}
      formik={{
        initialValues: {
          ...initialData,
          department: defaultDepartment,
          listCodeSource: listCodeSource,
        },
        onSubmit: async (values, formikHelpers) => {
          const data = await handleSubmit(values, formikHelpers);
          if (data?.responseStatus !== false) {
            await handleGetPatientOverviewByIdNotLoading(values?.patient?.id);
          }
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting}>
              {!isMobile && <Save className="mr-2 " />}
              Đặt cọc
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm customerSourceWalkIn={customerSourceWalkIn} />
            <DialogError values={values} setFieldValue={setFieldValue} />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({ customerSourceWalkIn }) => {
  const {
    listStk,
    listPaymentMethod,
    listPos,
    listHomecredit,
    listPos_tragop,
    getListProperties,
  } = useStore().feeStore.serviceFeeTabStore;
  const { values, setFieldValue } = useFormikContext();
  let POSITION_CODES = getPositionCodes();
  const isAdminPermission = isAdmin();
  const departmentsUser = getDepartmentsUser();

  const handleGetListCodeSource = async (obj, setFieldValue) => {
    try {
      const { data } = await getListCode(obj);
      setFieldValue("listCodeSource", data || []);
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={1} style={{ backgroundColor: "aliceblue" }}>
            <Grid item xs={12} sm={6} md={2}>
              <GlobitsPagingAutocomplete
                name={"department"}
                label={"Cơ sở"}
                api={
                  isAdminPermission
                    ? pagingDepartment
                    : async () => ({
                        data: {
                          content: departmentsUser || [],
                          totalElements: departmentsUser?.length || 0,
                          totalPages: 1,
                        },
                      })
                }
                required
                onChange={async (_, department) => {
                  setFieldValue("department", department);
                  const { listStk, listPos } = await getListProperties({
                    departmentIds: department ? [department.id] : [],
                  });
                  let voucherPaymentMethods =
                    values?.voucherPaymentMethods?.map((el) => {
                      if (
                        el?.paymentMethodValue?.characteristic ===
                        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                      ) {
                        return {
                          ...el,
                          bankName: listStk?.[0]?.propertyName,
                          bankAccountNumber: listStk?.[0]?.property,
                          paymentBank: listStk?.[0],
                        };
                      }
                      if (
                        el?.paymentMethodValue?.characteristic ===
                        PAYMENT_METHOD_CHARACTERISTIC_POS
                      ) {
                        return {
                          ...el,
                          bankName: listPos?.[0]?.propertyName,
                          bankAccountNumber: listPos?.[0]?.property,
                          paymentBank: listStk?.[0],
                        };
                      }
                      return el;
                    });

                  const searchCodeSource = {
                    level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                    startDate: values?.voucherDate,
                    patientId: values?.patient?.id,
                    departmentId: department?.id,
                    // voucherIds: values?.voucherAllocations?.map(item => item?.voucher?.id) || [],
                    // invoiceItemIds: values?.invoiceItemAllocations.map(item => item?.invoiceItem?.id) || []
                  };

                  handleGetListCodeSource(searchCodeSource, setFieldValue);

                  setFieldValue("voucherPaymentMethods", voucherPaymentMethods);
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <GlobitsPagingAutocomplete
                label="Người thu"
                name="accountant"
                displayLabel="staffName"
                api={pagingStaff}
                required
                searchObject={{
                  isActive: true,
                }}
                ListboxComponent={forwardRef((props, ref) => {
                  const { children, ...other } = props;
                  return (
                    <ul {...other} ref={ref}>
                      <ol>
                        <li>{children}</li>
                      </ol>
                    </ul>
                  );
                })}
                renderOption={(option) => renderOptionsStaff(option)}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <GlobitsDateTimePicker
                required
                label="Ngày thu"
                name="voucherDate"
                isDateTimePicker
                onChange={(value) => {
                  setFieldValue("voucherDate", value);
                  if (!value) return;

                  const searchCodeSource = {
                    level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                    startDate: value,
                    patientId: values?.patient?.id,
                    departmentId: values?.department?.id,
                    // voucherIds: values?.voucherAllocations?.map(item => item?.voucher?.id) || [],
                    // invoiceItemIds: values?.invoiceItemAllocations.map(item => item?.invoiceItem?.id) || []
                  };

                  handleGetListCodeSource(searchCodeSource, setFieldValue);
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <GlobitsVNDCurrencyInput label="Số tiền thu" name="totalAmount" />
            </Grid>
            {/* <Grid item xs={12} md={2}>
              <GlobitsSelectInput
                label="Doanh thu mới/cũ"
                name={`voucherItemRevenueType`}
                options={LAVoucherItemRevenueType.getListData()}
                onChange={(e) => {
                  const selectedValue = e?.target?.value;
                  setFieldValue(`voucherItemRevenueType`, selectedValue);
                }}
              />
            </Grid> */}
            <Grid item xs={12} md={2}>
              <GlobitsTextField
                isTextArea
                rows={2}
                label="Lý do /nội dung"
                name="note"
              />
            </Grid>
          </Grid>

          <Grid container spacing={1} className="mt-1">
            <Grid item xs={12} md={9}>
              <Grid container spacing={1}>
                <StaffRevenues POSITION_CODES={POSITION_CODES} />
              </Grid>
            </Grid>

            <Grid item xs={12} md={3} className="flex flex-end">
              <TotalOfVoucherByDeposit
                listPaymentMethod={listPaymentMethod}
                listStk={listStk}
                listPos={listPos}
                listPos_tragop={listPos_tragop}
                listHomecredit={listHomecredit}
                moneyAfterDiscount={values?.totalAmount || 0}
                nameSpace={"voucherPaymentMethods"}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
});

const StaffRevenues = ({ POSITION_CODES }) => {
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    let staffRevenues = values?.staffRevenues?.map((el) => ({
      ...el,
      actualAmount: ((values?.totalAmount || 0) * (el?.percentRevenue || 0)) / 100,
    }));
    setFieldValue("staffRevenues", staffRevenues);
  }, [values?.totalAmount]);

  return (
    <FieldArray name="staffRevenues">
      {({ remove, push }) => (
        <>
          <Grid item xs={12} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Nguồn"}
              name="sourceRevenue"
              api={pagingCustomerSource}
              searchObject={{
                level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                departmentId: values?.department?.id,
                patientId: values?.patient?.id,
                startDate: values?.voucherDate,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Chọn chức danh"}
              name="position"
              api={pagingPosition}
              searchObject={{
                isUsing: true,
                positionCodes: POSITION_CODES,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <GlobitsPagingAutocomplete
              disableClearable
              label={"Chọn nhân viên được phân bổ doanh thu"}
              api={pagingStaff}
              name={`staff`}
              displayLabel="staffName"
              autoUpercase
              searchObject={{
                positionId: values?.position?.id,
                isActive: true,
                excludeStatus: EXCLUDE_QUIT_STAFF,
              }}
              getOptionDisabled={(option) => {
                const selectedService = getIn(values, "staffRevenues");
                if (
                  selectedService?.find((it) => it?.staff?.id === option?.id)
                ) {
                  return true;
                }
                return false;
              }}
              ListboxComponent={forwardRef((props, ref) => {
                const { children, ...other } = props;
                return (
                  <ul {...other} ref={ref}>
                    <ol>
                      <li>{children}</li>
                    </ol>
                  </ul>
                );
              })}
              renderOption={(option) => renderOptionsStaff(option)}
            />
          </Grid>
          <Grid item xs={2} className="flex align-end">
            <CommonButton
              onClick={() => {
                push({
                  staff: values?.staff,
                  position: values?.position,
                  source: values?.sourceRevenue,
                  actualAmount: values?.totalAmount,
                  percentRevenue: 100,
                });
                setFieldValue("staff", null);
                setFieldValue("sourceRevenue", null);
                setFieldValue("position", null);
              }}
            >
              <ArrowDownward />
            </CommonButton>
          </Grid>

          <Grid item xs={12}>
            <div className="table-root mt-2">
              <div style={{ minWidth: "420px" }}>
                <table className="table-container">
                  <thead>
                    <tr className="row-table-header">
                      <th width="5%">STT</th>
                      <th width="20%">Nguồn</th>
                      <th width="17%">Chức danh</th>
                      <th width="18%">Nhân viên</th>
                      <th width="15%">Phân bổ (%)</th>
                      <th width="15%">Phân bổ (tiền)</th>
                      <th width="10%">Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values?.staffRevenues?.length > 0 &&
                      values?.staffRevenues?.map((item, index) => {
                        let positionName =
                          values?.staffRevenues[index]?.position?.name;
                        let staffName =
                          values?.staffRevenues[index]?.staff?.staffName;

                        if (!positionName) {
                          positionName = "Chưa lựa chọn";
                        }
                        if (!staffName) {
                          staffName = "Chưa lựa chọn";
                        }

                        return (
                          <tr key={index}>
                            <td align="center">{index + 1}</td>

                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingCustomerSource}
                                name={`staffRevenues[${index}].source`}
                                autoUpercase
                                searchObject={{
                                  level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                                  departmentId: values?.department?.id,
                                  patientId: values?.patient?.id,
                                  startDate: values?.voucherDate,
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingPosition}
                                name={`staffRevenues[${index}].position`}
                                autoUpercase
                                searchObject={{
                                  isUsing: true,
                                  positionCodes: POSITION_CODES,
                                }}
                                onChange={function (_, value) {
                                  setFieldValue(
                                    `staffRevenues[${index}].position`,
                                    value
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].staff`,
                                    null
                                  );
                                }}
                              />
                            </td>

                            <td>
                              <GlobitsPagingAutocomplete
                                api={pagingStaff}
                                name={`staffRevenues[${index}].staff`}
                                displayLabel={"staffName"}
                                autoUpercase
                                searchObject={{
                                  positionId:
                                    values?.staffRevenues[index]?.position?.id,
                                  isActive: true,
                                  excludeStatus: EXCLUDE_QUIT_STAFF,
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsNumberInput
                                name={`staffRevenues[${index}].percentRevenue`}
                                onChange={(e) => {
                                  let percentRevenue = +e?.target?.value;
                                  if (percentRevenue < 0) percentRevenue = 0;
                                  setFieldValue(
                                    `staffRevenues[${index}].percentRevenue`,
                                    percentRevenue
                                  );
                                  setFieldValue(
                                    `staffRevenues[${index}].actualAmount`,
                                    (percentRevenue * (values?.totalAmount || 0)) / 100
                                  );
                                }}
                              />
                            </td>
                            <td>
                              <GlobitsVNDCurrencyInput
                                name={`staffRevenues[${index}].actualAmount`}
                              />
                            </td>
                            <td align="center">
                              <span
                                tooltip={"Xóa"}
                                className="pointer tooltip"
                                onClick={() => remove(index)}
                              >
                                <IconDelete />
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </Grid>
        </>
      )}
    </FieldArray>
  );
};

const DialogError = observer(({ values, setFieldValue }) => {
  const { openConfirmMessage, handleCloseConfirmMessage } =
    useStore().feeStore.serviceFeeTabStore;
  return (
    <>
      {!!openConfirmMessage && (
        <ConfirmPopup
          open={!!openConfirmMessage}
          onClose={() => {
            handleCloseConfirmMessage(null);
            setFieldValue("voucherDate", new Date());
          }}
          text={openConfirmMessage}
          onConfirm={() => {
            const url =
              Config.ROOT_PATH +
              PathModule.PATIENT_MANAGEMENT +
              `/patient-general?patientId=${values?.patient?.id}`;

            window.open(url, "_blank");
          }}
          textConfirm={"Thông tin khách"}
          textClose={"Quay lại"}
          title="Thao tác thất bại"
          isNotAPromise
        />
      )}
    </>
  );
});
export default memo(observer(DepositFeePopup));
